/**
 * Fixed-timestep simulation loop. The sim advances in constant SIM_DT steps,
 * decoupled from the render frame rate — same discipline as the UE automation
 * tests: game logic stays deterministic and testable.
 */
export const SIM_DT = 1 / 30;

export class SimLoop {
  private accumulator = 0;
  private last = -1;
  /** Number of sim steps executed (useful for save/load + replays). */
  tickCount = 0;
  /** Simulation speed multiplier; 0 pauses. */
  timeScale = 1;

  constructor(private readonly step: (dt: number) => void) {}

  frame(nowMs: number): void {
    if (this.last < 0) this.last = nowMs;
    let frameDt = ((nowMs - this.last) / 1000) * this.timeScale;
    this.last = nowMs;
    // Clamp spiral-of-death: never simulate more than 250ms per frame.
    if (frameDt > 0.25) frameDt = 0.25;
    this.accumulator += frameDt;
    while (this.accumulator >= SIM_DT) {
      this.step(SIM_DT);
      this.tickCount++;
      this.accumulator -= SIM_DT;
    }
  }
}
